import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

// A text field stays scrolled to the caret after editing, which hides its ellipsis;
// scroll it back to the start when it loses focus.
document.addEventListener("focusout", (e) => {
  if (e.target instanceof HTMLInputElement && e.target.type === "text") e.target.scrollLeft = 0;
});

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
